import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import { addRegistration } from "../../Redux/WhatsappSlice/ExeRegistration";

const Add_Registration = () => {
  const dispatch = useDispatch();

  const { AllClients } = useSelector((state) => state.Client);
  // const { AddRegData } = useSelector((state) => state.ExeRegistration);

  const loginData = Cookies.get("loginData");
  const AdminData = loginData ? JSON.parse(loginData) : null;

  const [formData, setFormData] = useState({
    WhaClientName: "",
    Connection: "",
    Project: "",
    StaticIP: "",
    PhysicalAddress: "",
    RegisterStartDate: "2010-04-01",
    RegisterEndDate: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchAllClients());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClientSelect = (e) => {
    const selectedClientName = e.target.value;
    const selectedClient = AllClients?.data?.find(
      (client) => client.WhaClientName === selectedClientName
    );

    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    setFormData((prev) => ({
      ...prev,
      WhaClientName: selectedClientName,
      Project:
        selectedClient?.Project?.map((proj) => proj.project_name).join(", ") ||
        "",
      ProjectIDs: selectedClient?.Project?.map((proj) => proj._id) || [],
      StaticIP: selectedClient?.StaticIP || "",
      PhysicalAddress: selectedClient?.PhysicalAddress || "",
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.WhaClientName) newErrors.WhaClientName = "Client is required";
    if (!formData.Connection) newErrors.Connection = "Connection is required";
    if (!formData.Project) newErrors.Project = "Project is required";
    if (!formData.RegisterStartDate)
      newErrors.RegisterStartDate = "Start Date is required";
    if (!formData.RegisterEndDate)
      newErrors.RegisterEndDate = "End Date is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const selectedClient = AllClients?.data?.find(
        (client) => client.WhaClientName === formData.WhaClientName
      );

      const resultAction = await dispatch(
        addRegistration({
          values: formData,
          selectedClient,
          loginData: AdminData,
        })
      );

      if (resultAction.payload) {
        toast.success("Registration added successfully!", {
          position: "top-right",
        });

        setFormData({
          WhaClientName: "",
          Connection: "",
          Project: "",
          ProjectIDs: [],
          StaticIP: "",
          PhysicalAddress: "",
          RegisterStartDate: "2010-04-01",
          RegisterEndDate: "",
        });
      } else {
        toast.error("Failed to add registration.", {
          position: "top-right",
        });
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
      });
    }
  };

  return (
    <>
      <style>
        {`
            /* Hide number input arrows (Chrome, Safari, Edge) */
            input[type="number"]::-webkit-inner-spin-button,
            input[type="number"]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
            }

            /* Hide number input arrows (Firefox) */
            input[type="number"] {
            -moz-appearance: textfield;
            }
        `}
      </style>

      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            Add Exe Registration
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-md rounded-md mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Client Name</h5>
              <select
                name="WhaClientName"
                value={formData.WhaClientName}
                onChange={handleClientSelect}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Client</option>
                {[...(AllClients?.data || [])]
                  .sort((a, b) =>
                    a.WhaClientName.localeCompare(b.WhaClientName)
                  )
                  .map((client) => (
                    <option key={client._id} value={client.WhaClientName}>
                      {client.WhaClientName}
                    </option>
                  ))}
              </select>
              {errors.WhaClientName && (
                <p className="text-red-500 text-sm">{errors.WhaClientName}</p>
              )}
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Admin Name</h5>
              {/* <input type="hidden" name="AdminID" value={formData.AdminID} /> */}
              <input
                type="text"
                placeholder="Enter version number"
                value={AdminData?.data?.Name}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                readOnly
              />
            </div>

            {/* Connection Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Connection</h5>
              <input
                type="number"
                name="Connection"
                placeholder="Enter Connection number"
                value={formData.Connection}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded no-spinner"
              />
              {errors.Connection && (
                <p className="text-red-500 text-sm mt-1">{errors.Connection}</p>
              )}
            </div>

            {/* Project Dropdown */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Project</h5>
              <textarea
                name="Project"
                value={formData.Project}
                readOnly
                rows={Math.min(
                  Math.max(Math.ceil(formData.Project.length / 50), 1),
                  6
                )}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded  resize-y"
              />
              {errors.Project && (
                <p className="text-red-500 text-sm mt-1">{errors.Project}</p>
              )}
            </div>

            {/* Static IP Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Static IP</h5>
              <input
                type="text"
                name="StaticIP"
                placeholder="Enter Static IP Number"
                value={formData.StaticIP}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {/* {errors.StaticIP && (
                <p className="text-red-500 text-sm">{errors.StaticIP}</p>
              )} */}
            </div>

            {/* Physical Address Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Physical Address</h5>
              <input
                type="text"
                name="PhysicalAddress"
                placeholder="Enter Physical Address"
                value={formData.PhysicalAddress}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {/* {errors.PhysicalAddress && (
                <p className="text-red-500 text-sm">{errors.PhysicalAddress}</p>
              )} */}
            </div>

            {/* Register Start Date Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Register Start Date</h5>
              <input
                type="date"
                name="RegisterStartDate"
                value={formData.RegisterStartDate}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.RegisterStartDate && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.RegisterStartDate}
                </p>
              )}
            </div>

            {/* Register End Date Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mt-1 block font-semibold">Register End Date</h5>
              <input
                type="date"
                name="RegisterEndDate"
                value={formData.RegisterEndDate}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.RegisterEndDate && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.RegisterEndDate}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Add_Registration;
